import { render, staticRenderFns } from "./InstallInvalid.vue?vue&type=template&id=12600734&scoped=true&"
import script from "./InstallInvalid.vue?vue&type=script&lang=js&"
export * from "./InstallInvalid.vue?vue&type=script&lang=js&"
import style0 from "./InstallInvalid.vue?vue&type=style&index=0&id=12600734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12600734",
  null
  
)

export default component.exports